(function () {

  'use strict';

  angular.module('WorkstationList')

    .constant('WORKSTATIONS_FILTERS', [
      {
        name: 'Network',
        parameter: 'networkFilters',
        type: 'pagination',
        service: 'NetworkListService',
        paginationObject: null,
        supportIcon: 'icon-mobile-plain',
        values: []
      },
      {
        name: 'OperatingSystem',
        parameter: 'systems',
        type: 'checkbox',
        values: []
      },
      {
        name: 'WsType',
        parameter: 'types',
        type: 'checkbox',
        values: [
          {
            key: 'SERVER',
            value: 'SERVER',
            type: 'checkbox'
          },
          {
            key: 'DESKTOP',
            value: 'DESKTOP',
            type: 'checkbox'
          },
          {
            key: 'LAPTOP',
            value: 'LAPTOP',
            type: 'checkbox'
          }
        ]
      },
      {
        name: 'Platform',
        parameter: 'systems',
        type: 'checkbox',
        values: [
          {
            key: 'WIN',
            value: 'WIN',
            type: 'checkbox'
          },
          {
            key: 'MAC',
            value: 'MAC',
            type: 'checkbox'
          }
        ]
      },
      {
        name: 'ActAsCaptureGateway',
        parameter: 'scanGateway',
        type: 'radio',
        values: [
          {
            key: 'scanGateway',
            value: 'Yes',
            state: true
          },
          {
            key: 'scanGateway',
            value: 'No',
            state: false
          },
          {
            key: 'scanGateway',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'ActAsPrintGateway',
        parameter: 'printGateway',
        type: 'radio',
        values: [
          {
            key: 'printGateway',
            value: 'Yes',
            state: true
          },
          {
            key: 'printGateway',
            value: 'No',
            state: false
          },
          {
            key: 'printGateway',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'OnBehalfOfLabel',
        parameter: 'onBehalfOf',
        type: 'radio',
        values: [
          {
            key: 'onBehalfOf',
            value: 'Yes',
            state: true
          },
          {
            key: 'onBehalfOf',
            value: 'No',
            state: false
          },
          {
            key: 'onBehalfOf',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'ONLINE',
        parameter: 'active',
        type: 'radio',
        values: [
          {
            key: 'active',
            value: 'Yes',
            state: true
          },
          {
            key: 'active',
            value: 'No',
            state: false
          },
          {
            key: 'active',
            value: 'ClearFilter',
            state: null
          }
        ]
      }
    ])

    .constant('SORT_WORKSTATIONS', {
      NAME: 'HostName'
    })

    .controller('WorkstationListController', function (
      $scope, $filter, SUPPORTED_OS, WorkstationListService, $location, URLS,
      $ngBootbox, URL_PARAMS, NetworkListService, toastr,
      WORKSTATIONS_FILTERS, SORT_WORKSTATIONS, $rootScope, FilterDropdownService,
      NetworkListPaging, EventHandlerService, currentTenant, WorkstationListPOSTPaging,
      $routeParams, $window, $timeout) {

      // Var declaration
      $scope.orderByText = 'HostName';
      $scope.reverse = false;
      $scope.showSearchField = false;
      $scope.searchInputFieldHolderFocusKey = 'searchInputFieldHolderFocusKey';
      $scope.checkAllCheckboxes = false;
      $scope.networkListService = NetworkListService;
      $scope.selectedWorkstations = 0;
      $scope.supportedOs = SUPPORTED_OS;
      $scope.unknownNetwork = {
        info: {
          name: 'UnknownNetwork'
        }
      };
      $scope.lastPageReached = false;
      $scope.noDataMessage = 'NoSearchResultComputer';
      $scope.filtersList = null;
      $scope.workstationListPaging = new WorkstationListPOSTPaging();
      $scope.requestType = 'POST';
      $scope.workstationContainer = null;
      $scope.searchInputPlaceholderText = 'SearchComputerByName';
      $scope.helpCaption = 'HelpComputersPage';
      $scope.filterNetworkListPaging = new NetworkListPaging();
      $scope.eventHandlerService = EventHandlerService;
      const workstationsFilters = angular.copy(WORKSTATIONS_FILTERS);
      $scope.me = null;
      let initialListRequest = true;
      $scope.windowWidth = $window.innerWidth;
      $scope.loadingPage = true;

      (function () {
        initEventHandler();
      })();

      function initEventHandler() {
        $scope.eventHandlerService.deRegisterListeners();
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          const workstationsFilters = angular.copy(WORKSTATIONS_FILTERS);
          initFilters(adjustToUserPermissions(workstationsFilters));
        }
      });

      function adjustToUserPermissions(workstationsFilters) {
        workstationsFilters[0].paginationObject = $scope.filterNetworkListPaging;
        if (!$scope.me.permissions.TENANT_ADMIN) {
          $scope.workstationListPaging.pagingCriteria.networkFilterEnabled = true;
          $scope.workstationListPaging.pagingCriteria.networkFilters = $scope.me.networks;
          workstationsFilters[0].paginationObject.pagingCriteria.sites = $scope.me.sites.map(site => site.id) || [];
        }
        return workstationsFilters;
      }

      function initFilters(workstationsFilters) {
        workstationsFilters[1].values = FilterDropdownService.addInputType(reduceAmountOfOS());
        if (workstationsFilters[1].values <= 0) {
          workstationsFilters.splice(1, 1);
        }

        $scope.workstationListPaging.pagingCriteria.page = $routeParams.workstationPage > 1 ? $routeParams.workstationPage - 1 : 0;
        $scope.filtersList = workstationsFilters;
      }

      function reduceAmountOfOS() {
        const reducedSupportedOs = [];
        const avaliableOS = currentTenant.info._embedded.wsCountPerOs.wsCountPerOs;
        for (const key in avaliableOS) {
          for (let i = 0; i < SUPPORTED_OS.length; i++) {
            if (SUPPORTED_OS[i].key === key) {
              reducedSupportedOs.push(SUPPORTED_OS[i]);
            }
          }
        }
        reducedSupportedOs.sort(function (a, b) {
          return a.value.localeCompare(b.value);
        });
        return reducedSupportedOs;
      }

      function reportWindowSize() {
        $scope.windowWidth = $window.innerWidth;
        $scope.$apply();
      }

      $window.onresize = reportWindowSize;

      $scope.deleteWorkstation = function (workstation) {
        if (workstation) {
          $ngBootbox.confirm($filter('stringular')($filter('translate')('DeleteComputer'), workstation.info.name))
            .then(function () {
              WorkstationListService.deleteWorkstation(workstation).then(function () {
                toastr.success($filter('stringular')($filter('translate')('ComputerDeleted'), workstation.info.name));
              }).catch(function () {});
            }).catch(function () {});
        } else {
          throw new Error('$scope.deleteWorkstation: workstation is missing');
        }
      };

      $scope.deleteSelectedWorkstations = function () {
        if ($scope.workstationContainer.list.length > 0) {
          const workstationList = $scope.workstationContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (workstationList.length > 0) {
            let message = '';
            if (workstationList.length < 2) {
              message = $filter('stringular')($filter('translate')('DeleteComputer'), workstationList[0].info.name);
            } else {
              message = $filter('stringular')($filter('translate')('DeleteComputers'), workstationList.length);
            }
            $ngBootbox.confirm(message)
              .then(function () {
                WorkstationListService.deleteSelectedWorkstations(workstationList, function () {
                  let message = '';
                  if (workstationList.length < 2) {
                    message = $filter('stringular')($filter('translate')('ComputerDeleted'), workstationList[0].info.name);
                  } else {
                    message = $filter('stringular')($filter('translate')('ComputersDeleted'), workstationList.length);
                  }
                  toastr.success(message);
                });
              }).catch(function () {});
          } else {
            toastr.error($filter('translate')('SelectComputerNone') + ', ' + $filter('translate')('SelectComputer'));
          }
        } else {
          toastr.error($filter('translate')('SelectComputerNone'));
        }
      };

      $scope.changeOrderByValue = function (textValue) {
        if ($scope.reverse) {
          $scope.reverse = false;
          $scope.workstationListPaging.pagingCriteria.direction = 'ASC';
          $scope.workstationListPaging.pagingCriteria.sort = textValue;
        } else {
          $scope.reverse = !$scope.reverse;
          $scope.workstationListPaging.pagingCriteria.direction = 'DESC';
          $scope.workstationListPaging.pagingCriteria.sort = textValue;
        }
        $scope.orderByText = SORT_WORKSTATIONS[textValue];
        $scope.getWorkstationListPaged();
      };

      $scope.orderByNetworkNames = function (workstation) {
        if (workstation) {
          return workstation.customProperties.networkNames;
        } else {
          throw new Error('$scope.orderByNetworkNames: workstation is missing');
        }
      };

      $scope.editSelectedWorkstations = function (workstation, showSection) {
        if ($scope.workstationContainer.list.length > 0) {
          const selectedItems = $scope.workstationContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          });
          if (selectedItems.length > 0 || workstation) {
            if (workstation || selectedItems.length === 1) {
              if (!workstation) {
                workstation = selectedItems[0];
              }
              const url = URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id);
              $location.path(url).search(URL_PARAMS.SHOW_WORKSTATION_SECTION.ROUTE, showSection);
            } else {
              $location.path(URLS.WORKSTATION_PROPERTIES_MULTI);
            }
          } else {
            throw new Error('$scope.editSelectedUsers: selectedItems or user are missing');
          }
        }
      };

      $scope.selectAllItems = function () {
        angular.forEach($scope.workstationContainer.list, function (value) {
          value.options.isSelected = $scope.checkAllCheckboxes;
        });
      };

      $scope.getWorkstationListPaged = function (skipResetScroll) {
        if (!skipResetScroll) {
          angular.element('.px-scrollbar-scroll').scrollTop(0);
        }

        $scope.loadingPage = true;
        $scope.eventHandlerService.queue.stopQueue();

        if (!$scope.me.permissions.TENANT_ADMIN) {
          if (!$scope.workstationListPaging.pagingCriteria.networkFilters?.length) {
            $scope.workstationListPaging.pagingCriteria.networkFilters = $scope.me.networks;
          }
        }
        WorkstationListService.postGetWorkstationListPaged($scope.workstationListPaging).then(function (workstationContainer) {
          $scope.loadingPage = false;
          if (initialListRequest || $scope.workstationListPaging.pagingCriteria.page === 0) {
            initialListRequest = false;
            $location.path($location.path(), false).search({ workstationPage: parseInt($scope.workstationListPaging.pagingCriteria.page) + 1 }).replace();
          } else {
            $location.path($location.path(), false).search({ workstationPage: parseInt($scope.workstationListPaging.pagingCriteria.page) + 1 });
          }

          $scope.workstationContainer = angular.copy(workstationContainer);
          if ($scope.eventHandlerService.getControllerScope() !== 'workstationsList') {
            $scope.eventHandlerService.setControllerScopeData('workstationsList', $scope.workstationContainer.list);
          } else {
            refreshEventHandler();
          }
          workstationsFilters[1].values = FilterDropdownService.addInputType(reduceAmountOfOS());
        }).catch(function () {});
      };

      function getWorkstationByUrl(workstationId, taskName)  {
        $scope.eventHandlerService.queue.stopQueue();
        WorkstationListService.getWorkstationByUrl(workstationId).then(function (workstation) {
          for (let i = 0; i < $scope.workstationContainer.list.length; i++) {
            if ($scope.workstationContainer.list[i].info._links.self.href === workstation.info._links.self.href) {
              $scope.workstationContainer.list[i].info = workstation.info;
            }
          }
          refreshEventHandler();
          workstationsFilters[1].values = FilterDropdownService.addInputType(reduceAmountOfOS());
        }).catch(function () {});
      }

      function refreshEventHandler() {
        $scope.eventHandlerService.refreshScopeData('workstationsList', $scope.workstationContainer.list).then(function () {
          $scope.eventHandlerService.queue.setState('idle');
        }).catch(function () {});
      }

      $scope.getNextPage = function functionName(showPrevious) {
        if (showPrevious) {
          if ($scope.workstationListPaging.pagingCriteria.page > 0) {
            $scope.workstationListPaging.pagingCriteria.page--;
          }
        } else {
          if ($scope.workstationListPaging.pagingCriteria.page + 1 < $scope.workstationContainer.page.totalPages) {
            $scope.workstationListPaging.pagingCriteria.page++;
          }
        }
        $scope.getWorkstationListPaged();
      };

      $scope.openPrintixClientUpdateDialog = function (workstation) {
        $scope.showPrintixClientUpdateDialog = true;
        $scope.printixClientUpdateWorkstation = workstation;
      };

      $scope.closePrintixClientUpdateDialog = function () {
        $scope.showPrintixClientUpdateDialog = false;
        $scope.printixClientUpdateWorkstation = undefined;
      };

      const WORKTATIONS_LIST_listener = $rootScope.$on('workstationsList', function (name, data) {
        switch (data.operation) {
          case 'refreshList':
            $scope.getWorkstationListPaged(true);
            break;
          case 'replaceItem':
            getWorkstationByUrl(data.itemId);
            break;
        }
      });

      $scope.$on('$destroy', function () {
        WORKTATIONS_LIST_listener();
      });

      $scope.$watch(function () {
        if ($scope.workstationContainer) {
          return $scope.workstationContainer.list;
        }
      }, function () {
        if ($scope.workstationContainer) {
          $scope.selectedWorkstations = $scope.workstationContainer.list.findAllElements({
            options: {
              isSelected: true
            }
          }).length;
          if (!$scope.selectedWorkstations) {
            $scope.checkAllCheckboxes = false;
          } else {
            $scope.checkAllCheckboxes = ($scope.selectedWorkstations === $scope.workstationContainer.list.length);
          }
        }
      }, true);

      // TOOLTIP STUFF
      $scope.showTooltip = function (showTip, position, tooltipScope, context) {
        if (showTip) {
          switch (tooltipScope) {
            case 'site':
              siteTooltip(position, context);
              break;
            case 'queue':
              queueTooltip(position, context);
              break;
          }
        } else {
          $scope.clearTooltip();
        }
      };

      function siteTooltip(position, title) {

        $scope.clearTooltip();
        $scope.tooltipContent = {
          title,
          type: 'statement'
        };

        $scope.tooltipObject = {
          position: { left: position.startX, top: position.startY + 20 }
        };
      }

      function queueTooltip(position, queue) {
        $scope.clearTooltip();
        $scope.tooltipContent = {
          title: 'Queue',
          type: 'queueDetails',
          queue: queue.info
        };
        $scope.tooltipObject = {
          position: { left: position.startX - 15, top: position.startY + 20 },
          contextMenu: false
        };
      }

      $scope.clearTooltip = function () {
        $scope.tooltipContent = null;
        $scope.tooltipObject = null;
      };

      // LIST MENU
      $scope.openListMenu = function (event, workstation) {
        const position = document.getElementById(event.target.id).getBoundingClientRect();
        $timeout(function () {
          $scope.closeListMenu();
          $scope.listMenuContext = workstation;
          $scope.listMeta = {
            position: { left: position.x, top: position.y },
            parentId: event.target.id,
            type: 'workstationList',
            scrollContainerId: 'WorkstationScrollContainer',
            isTenantAdmin: $scope.me.permissions.TENANT_ADMIN
          };
        });
      };

      $scope.closeListMenu = function (workstation, action) {
        $scope.listMenuContext = null;
        $scope.listMeta = null;

        switch (action) {
          case 'DELETE_WORKSTATION':
            $scope.deleteWorkstation(workstation);
            break;
          case 'UPDATE_PRINTIX_CLIENT_ON_WORKSTATION':
            $scope.openPrintixClientUpdateDialog(workstation);
            break;
        }
      };

    });

})();
